(function () {
  var frames = document.querySelectorAll('.ekomi-iframe');
  if (!frames.length) return;

  var s = String.fromCharCode(60) + 'script' + String.fromCharCode(62);
  var e = String.fromCharCode(60) + '/script' + String.fromCharCode(62);

  frames.forEach(function (frame) {
    var certId = frame.getAttribute('data-cert');
    var integrationId = frame.getAttribute('data-integration');
    if (!certId || !integrationId) return;

    var protocol = (location.protocol === 'https:' ? 'https:' : 'http:');
    var scriptSrc = protocol + '//connect.ekomi.de/integration_' + integrationId + '/' + certId + '.js?_=' + Math.random();

    var html =
      '<!doctype html><html><head><meta charset="utf-8">' +
      '<style>html,body{margin:0;padding:0;background:transparent !important;}body>*{background:transparent !important;}</style>' +
      '</head><body>' +
      '<div id="eKomiWidget_default"></div>' +
      s +
      'var eKomiIntegrationConfig=[{certId:"' + certId + '"}];' +
      'var sc=document.createElement("script");' +
      'sc.type="text/javascript";sc.defer=true;' +
      'sc.src="' + scriptSrc + '";' +
      'document.head.appendChild(sc);' +
      e +
      '</body></html>';

    try {
      var doc = frame.contentDocument || frame.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();
    } catch (err) {
      if (window.console) console.error('eKomi iframe error:', err);
    }
  });
})();